import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from "../../app/constants"

const collectorBeforeStartConfirmationState = () => ({
    'collection-agency-collector' : {
        header : 'Before you start the application',
        navigation : {
            next : ROUTE_PATH.COLLECTOR_DETAILS
        }
    },
    'debt-management-agent' : {
        header : 'Before you start the application',
        navigation : {
            next : ROUTE_PATH.COLLECTOR_DETAILS
        }
    }
})

const collectorBeforeStartConfirmationSlice = createSlice({
    name: 'collectorBeforeStartConfirmation',
    initialState : collectorBeforeStartConfirmationState(),
    reducers : {
        setCollectorBeforeStartConfirmationAgree(state, action) { 
            state.collectorBeforeStartConfirmationAgree = true
        }
    }
})

export const {setCollectorBeforeStartConfirmationAgree} = collectorBeforeStartConfirmationSlice.actions
export default collectorBeforeStartConfirmationSlice.reducer

